import(/* webpackMode: "eager" */ "/vercel/path0/app/[username]/page.tsx");
